import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGiftFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M8.19531 4.63672C8.00391 4.28125 7.62109 4.0625 7.21094 4.0625H7.15625C6.52734 4.0625 6.0625 4.55469 6.0625 5.15625C6.0625 5.78516 6.52734 6.25 7.15625 6.25L9.125 6.25H9.15234L8.19531 4.63672ZM4.75 5.15625C4.75 3.84375 5.81641 2.75 7.15625 2.75H7.21094C8.08594 2.75 8.87891 3.21484 9.31641 3.98047L10 5.10156L10.6562 3.98047C11.0938 3.21484 11.8867 2.75 12.7617 2.75H12.8438C14.1562 2.75 15.25 3.84375 15.25 5.15625C15.25 5.56641 15.1406 5.92187 14.9766 6.25H16.125C16.5898 6.25 17 6.66016 17 7.125V8.875C17 9.36719 16.5898 9.75 16.125 9.75L3.875 9.75C3.38281 9.75 3 9.36719 3 8.875V7.125C3 6.66016 3.38281 6.25 3.875 6.25H4.99609C4.83203 5.92187 4.75 5.56641 4.75 5.15625ZM13.9375 5.15625C13.9375 4.55469 13.4453 4.0625 12.8438 4.0625H12.7617C12.3516 4.0625 11.9961 4.28125 11.7773 4.63672L10.8203 6.25H10.875H12.8438C13.4453 6.25 13.9375 5.78516 13.9375 5.15625ZM3.875 10.625L9.125 10.625L9.125 16.75H5.1875C4.44922 16.75 3.875 16.1758 3.875 15.4375L3.875 10.625ZM10.875 16.75L10.875 10.625H16.125L16.125 15.4375C16.125 16.1758 15.5234 16.75 14.8125 16.75L10.875 16.75Z"
	})
});
const ForwardRef = forwardRef(SvgGiftFilled);
export default ForwardRef;
